import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Add, KeyboardArrowDownRounded } from '@mui/icons-material';
import { Box, Button, Chip, Dialog, DialogContent, Divider, Grid, Menu, MenuItem, MenuList, Stack, Typography, useMediaQuery } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Config } from '../../api/config';
import { DashboardSearchIcon } from '../../assets/customIcons';
import { ArrowDownIconNew, CalenderIconBlack } from '../../assets/images';
import { EUserRole, LOCAL_STORAGE_KEYS, Module, ModuleName, dateBeforeMonth, dateBeforeWeek, headerTitle, isModuleConfig } from '../../constants';
import { setIsAllViewActive } from '../../redux/commonSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { getLocalStorageItem } from '../../utils/storageHelper';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { formDateFormate, maxDays } from '../../utils/utils';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiStack } from '../atoms/stackComponent';
import ToggleIconButtonComponent from '../atoms/toggleIconButtonComponent';
import DashboardSearch from './search/dashboardSearch';
var newTheme = createTheme({
    components: {
        MuiPickersCalendarHeader: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: "".concat(systemColor.primary, " !important"),
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                label: {
                    fontSize: '16px',
                    color: '#1B1D21',
                    fontWeight: '500',
                    fontFamily: 'NotoSans-Regular'
                }
            }
        },
        MuiDayCalendar: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                weekDayLabel: {
                    fontSize: '14px',
                    fontWeight: '400',
                    color: systemColor.primary,
                    fontFamily: 'NotoSans-Regular'
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                // today: {
                //     backgroundColor: '#F4F7FA',
                //     border: '1px solid #F4F7FA',
                //     borderColor: '#F4F7FA'
                // },
                selected: {
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Adjust text color
                    }
                },
                dayWithMargin: {
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#1B1D21',
                    fontFamily: 'NotoSans-Regular'
                }
            }
        }
    }
});
var ListPageHeaderComponent = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var handleClickFilterIcon = props.handleClickFilterIcon, selectedMenuItem = props.selectedMenuItem, menus = props.menus, onSelectMenu = props.onSelectMenu, isFromDashboard = props.isFromDashboard, onCalendarFilterApply = props.onCalendarFilterApply, isFromNewDashboard = props.isFromNewDashboard, activeView = props.activeView, onToggleView = props.onToggleView, isDashboard = props.isDashboard, totalCount = props.totalCount, onClickCreateModule = props.onClickCreateModule, createButtonText = props.createButtonText, isCreateButton = props.isCreateButton, moduleName = props.moduleName, title = props.title, loadingState = props.loadingState;
    var trackButtonClick = useAnalyticsEventTracker("ListPageHeaderComponent");
    var localFromDate = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE)) !== null && _getLocalStorageItem !== void 0 ? _getLocalStorageItem : formDateFormate(dateBeforeWeek);
    var localToDate = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE)) !== null && _getLocalStorageItem2 !== void 0 ? _getLocalStorageItem2 : formDateFormate(dayjs());
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var inspection = useParams().inspection;
    var dispatch = useAppDispatch();
    var location = useLocation();
    var IS_MOBILE = upXS && downSM;
    var IS_TABLET = upSM && dowMd;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(false), openCalendarFilter = _b[0], setOpenCaledarFilter = _b[1];
    var _c = useState(false), isFromDateCalOpen = _c[0], setIsFromDateCalOpen = _c[1];
    var _d = useState(false), isToDateCalOpen = _d[0], setIsToateCalOpen = _d[1];
    var _e = useState(""), pageTitle = _e[0], setPageTitle = _e[1];
    var _f = useState(false), isSearchActive = _f[0], setIsSearchActive = _f[1];
    var _g = useState(localFromDate), fromDate = _g[0], setFromDate = _g[1];
    var _h = useState(localToDate), toDate = _h[0], setToDate = _h[1];
    var _j = useState(false), toDateError = _j[0], setToDateError = _j[1];
    var open = Boolean(anchorEl);
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var MaxDateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    function getPageTitle() {
        var path = window.location.pathname.substring(1).toLowerCase();
        var selectedMenuItem = '';
        var title = headerTitle.some(function (menu) {
            var lowercasePaths = menu.paths.map(function (p) { return p.toLowerCase(); });
            if (lowercasePaths.some(function (p) { return path.startsWith(p); })) {
                selectedMenuItem = menu.section;
                return true;
            }
            return false;
        });
        if (Module === isModuleConfig.Bajaj && inspection) {
            setPageTitle("HEADER_TITLE_VI");
            return 'HEADER_TITLE_VI';
        }
        else {
            setPageTitle(title ? selectedMenuItem : '');
            return title ? selectedMenuItem : '';
        }
    }
    useEffect(function () {
        getPageTitle();
    }, [location]);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var openFromDateCalendar = function () {
        setIsFromDateCalOpen(true);
        setIsToateCalOpen(false);
    };
    var openToDateCalendar = function () {
        setIsToateCalOpen(true);
        setIsFromDateCalOpen(false);
    };
    var onFromDateCalendarClick = function (newValue) {
        var date = formDateFormate(newValue);
        setFromDate(date);
        setToDate("");
        setToDateError(true);
    };
    var onToDateCalendarClick = function (newValue) {
        var date = formDateFormate(newValue);
        setToDate(date);
        setToDateError(false);
    };
    var onResetClick = function () {
        if (selectedDesignationStorage.Name === EUserRole.FloorSupervisor) {
            setFromDate(formDateFormate(dateBeforeMonth));
        }
        else {
            setFromDate(formDateFormate(dateBeforeWeek));
        }
        setToDate(formDateFormate(dayjs()));
        setToDateError(false);
    };
    var onApplyClick = function () {
        setOpenCaledarFilter(false);
        setIsFromDateCalOpen(false);
        setIsToateCalOpen(false);
        var fromCalDate = fromDate !== null && fromDate !== void 0 ? fromDate : formDateFormate((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateBeforeMonth : dateBeforeWeek);
        var toCalDate = toDate !== null && toDate !== void 0 ? toDate : formDateFormate(dayjs());
        onCalendarFilterApply(fromCalDate, toCalDate);
    };
    var onCancelClick = function () {
        setFromDate(localFromDate !== null && localFromDate !== void 0 ? localFromDate : formDateFormate((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateBeforeMonth : dateBeforeWeek));
        setToDate(localToDate !== null && localToDate !== void 0 ? localToDate : formDateFormate(dayjs()));
        setOpenCaledarFilter(false);
        setIsFromDateCalOpen(false);
        setIsToateCalOpen(false);
    };
    var DashboardMenuArray = ['My View', 'All View'];
    var _k = useState(DashboardMenuArray[0]), selectedView = _k[0], setSelectedView = _k[1];
    var selectView = function (item) {
        dispatch(setIsAllViewActive(item === 'My View' ? false : true));
        setSelectedView(item);
    };
    useEffect(function () {
        if (isAllViewActive) {
            setSelectedView("All View");
        }
        else {
            setSelectedView("My View");
        }
    }, [isAllViewActive]);
    var getRequest = function () {
        var request = _objectSpread({}, filterValue);
        if (filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate) {
            request.FromDate = filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate;
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate) {
            request.ToDate = filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate;
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.Status) {
            var filterData = filterValue === null || filterValue === void 0 ? void 0 : filterValue.Status;
            request.Status = filterData.map(function (item) {
                return item.Key;
            });
        }
        return request;
    };
    var selectViewContentMobile = /*#__PURE__*/ React.createElement(MuiStack, {
        height: "auto"
    }, pageTitle !== ModuleName.Dashboard ? /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'space-between',
        sx: {
            alignItems: 'center'
        }
    }, menus ? /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        width: '100%',
        p: 2,
        columnGap: 1
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "select-moodule-type",
        name: selectedMenuItem ? t(selectedMenuItem) : '',
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement(KeyboardArrowDownRounded, {
            color: "inherit"
        }),
        sx: {
            fontWeight: 'strong',
            fontSize: 'lg',
            px: 0,
            py: 0,
            borderRadius: 0
        },
        onClick: handleClick,
        color: "inherit"
    }, selectedMenuItem ? t(selectedMenuItem) : ''), /*#__PURE__*/ React.createElement(Chip, {
        label: totalCount !== null && totalCount !== void 0 ? totalCount : 0,
        color: "info",
        size: "small"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        bgcolor: "secondary.100",
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "secondary.200",
        columnGap: 2,
        p: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "search-container",
        width: '100%',
        justifyContent: 'flex-start'
    }, /*#__PURE__*/ React.createElement(DashboardSearch, {
        request: getRequest(),
        moduleName: moduleName,
        selectedMenuItem: selectedMenuItem,
        isSearchActive: isSearchActive
    })), /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        size: 'icon',
        onClick: function () {
            handleClickFilterIcon();
            trackButtonClick("ButtonClickEvent", "Desktop_Filter_Open", undefined);
        },
        id: "filterButtonId",
        color: "secondary"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "".concat(Config.CDNBaseURL, "filterButtonNew.svg"),
        id: "filterIcon",
        alt: "settingIcon",
        loading: "lazy",
        style: {
            margin: '-10px'
        }
    })))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        sx: {
            whiteSpace: 'nowrap'
        }
    }, pageTitle ? t(pageTitle) : title), /*#__PURE__*/ React.createElement(MuiStack, {
        p: 1,
        border: '1px solid #AFD5FF',
        borderRadius: '10px',
        bgcolor: '#EEF6FF'
    }, loadingState === "loading" ? 0 : totalCount || 0)), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                if (onSelectMenu) {
                    trackButtonClick("ButtonClickEvent", "Mobile_Menu_Select_" + "".concat(item), undefined);
                    onSelectMenu(item);
                    onResetClick();
                    handleClose();
                }
            }
        }, t(item));
    })))))) : /*#__PURE__*/ React.createElement(MuiStack, {
        py: 2
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "select-moodule-type",
        name: selectedView,
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement(KeyboardArrowDownRounded, {
            color: "inherit"
        }),
        sx: {
            fontWeight: 'strong',
            fontSize: 'lg',
            color: 'text.primary',
            p: 0,
            borderRadius: 0
        },
        onClick: handleClick
    }, " ", selectedView, " "), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, DashboardMenuArray && (DashboardMenuArray === null || DashboardMenuArray === void 0 ? void 0 : DashboardMenuArray.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === DashboardMenuArray.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                trackButtonClick("ButtonClickEvent", "Mobile_Menu_Select_" + "".concat(item), undefined);
                selectView(item);
                handleClose();
            }
        }, t(item));
    })))))));
    var selectViewContentDesktop = /*#__PURE__*/ React.createElement(MuiStack, {
        height: isFromNewDashboard ? '0px' : 'auto',
        py: 2,
        px: 3
    }, menus && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            alignItems: 'center'
        },
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "select-module-types",
        name: selectedMenuItem ? t(selectedMenuItem) : '',
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement("img", {
            id: "dropdownIcon",
            src: ArrowDownIconNew,
            alt: "dropdown",
            height: '20px',
            width: '20px',
            loading: "lazy"
        }),
        sx: {
            fontWeight: 'strong',
            fontSize: 'xxl',
            color: 'text.primary',
            textTransform: "none",
            padding: 0
        },
        onClick: handleClick
    }), /*#__PURE__*/ React.createElement(Chip, {
        color: "info",
        variant: "filled",
        size: "medium",
        label: totalCount || 0
    }), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: '500',
                fontSize: '14px',
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize',
                color: '#6A7682'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                if (onSelectMenu) {
                    trackButtonClick("ButtonClickEvent", "Desktop_Menu_Select_" + "".concat(item), undefined);
                    onSelectMenu(item);
                    onResetClick();
                    handleClose();
                }
            }
        }, t(item));
    })))))));
    var showMyViewAllView = function () {
        // if (IS_MOBILE) {
        //     if (isFromNewDashboard) {
        //         return false
        //     } else {
        //         return true
        //     }
        // }
        // if (IS_TABLET) {
        //     if (isFromNewDashboard) {
        //         return false
        //     } else {
        //         return true
        //     }
        // }
        // if (IS_DESKTOP) {
        //     return false
        // }
        return true;
    };
    return /*#__PURE__*/ React.createElement(Box, null, 
    // { showMyViewAllView()
    // ? 
    IS_MOBILE ? selectViewContentMobile
        // : !isFromNewDashboard &&
        // <Stack direction='row' columnGap={1}>
        //     <Typography fontSize='xxl' fontWeight='strong' sx={{ whiteSpace: 'nowrap' }}>{pageTitle ? t(pageTitle) : (title)}</Typography>
        //     <Chip color='info' variant='filled' size='large' label={totalCount || 0} />
        // </Stack> 
        : null, isFromNewDashboard && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        bgcolor: '#EFF2F5',
        marginLeft: '-16px !important',
        marginRight: '-16px !important'
    }, /*#__PURE__*/ React.createElement(Divider, {
        flexItem: true,
        variant: "fullWidth"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        px: 2,
        justifyContent: 'space-between',
        alignItems: "center",
        gap: 0.5,
        sx: {
            placeItems: 'center'
        },
        width: isSearchActive ? {
            xs: '100%',
            md: '60%'
        } : {
            xs: '100%'
        }
    }, !isSearchActive && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        alignItems: 'start'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "strong",
        color: "text.tertiary"
    }, t("Viewing stats for")), /*#__PURE__*/ React.createElement(Typography, {
        id: "date-range"
    }, localFromDate != null ? formDateFormate(localFromDate) : formDateFormate(dateBeforeWeek), " - ", localToDate != null ? formDateFormate(localToDate) : formDateFormate(dayjs()))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'end',
        gap: '12px'
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "calendar-btn",
        variant: "outlined",
        size: "icon",
        color: "secondary",
        disableRipple: true,
        disableTouchRipple: true,
        onClick: function () {
            setOpenCaledarFilter(true);
            setIsFromDateCalOpen(true);
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "calander-icon",
        alt: "calander",
        style: {
            height: '20px',
            width: '20px'
        },
        src: CalenderIconBlack
    })), !isSearchActive && /*#__PURE__*/ React.createElement(Button, {
        id: "dashboard-search-btn",
        variant: "outlined",
        size: "icon",
        color: "secondary",
        disableRipple: true,
        disableTouchRipple: true,
        onClick: function () { return setIsSearchActive(true); }
    }, /*#__PURE__*/ React.createElement(DashboardSearchIcon, {
        id: "DashboardSearch",
        color: "secondary",
        width: "20px",
        height: "20px"
    }))), isSearchActive && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DashboardSearch, {
        request: {
            FromDate: fromDate ? new Date(fromDate).toISOString() : dateBeforeWeek.toISOString(),
            ToDate: toDate ? new Date(toDate).toISOString() : dayjs().toISOString()
        },
        moduleName: pageTitle,
        isSearchActive: isSearchActive
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Cancel",
        variant: "text",
        sx: {
            background: 'none',
            ml: '3px'
        },
        onClick: function () { return setIsSearchActive(false); }
    }))), /*#__PURE__*/ React.createElement(Divider, {
        flexItem: true,
        variant: "fullWidth"
    })), openCalendarFilter &&
        /*#__PURE__*/
        // <Dialog open={openCalendarFilter} onClose={() => { setOpenCaledarFilter(false); setIsFromDateCalOpen(false); setIsToateCalOpen(false) }} fullWidth style={{ background: 'none', width: '100%', height: '100%' }}>
        React.createElement(Dialog, {
            open: openCalendarFilter,
            onClose: function () { return onCancelClick(); },
            fullWidth: true,
            style: {
                background: 'none',
                width: '100%',
                height: '100%'
            }
        }, /*#__PURE__*/ React.createElement(DialogContent, {
            style: {
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between",
            sx: {
                padding: '20px 30px 0px 30px'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Button, {
            sx: {
                width: '100%',
                padding: '8px 8px',
                marginTop: '8px',
                borderRadius: '8px',
                border: '1px solid #DEE4EB',
                boxShadow: '0px 1px 5px 0px rgba(16, 24, 40, 0.05)',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                borderColor: isFromDateCalOpen ? '#1B1D21' : '#DEE4EB'
            },
            onClick: function () { return openFromDateCalendar(); }
        }, /*#__PURE__*/ React.createElement("img", {
            id: "cal-icon-from",
            src: CalenderIconBlack,
            alt: "calander"
        }), /*#__PURE__*/ React.createElement(Typography, {
            id: "from-date",
            variant: "body2",
            sx: {
                marginLeft: '2px',
                color: '#1B1D21',
                opacity: fromDate ? 1 : 0.5
            }
        }, fromDate || 'From date'))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Button, {
            sx: {
                width: '100%',
                padding: '8px 8px',
                marginTop: '8px',
                borderRadius: '8px',
                border: '1px solid red',
                boxShadow: '0px 1px 5px 0px rgba(16, 24, 40, 0.05)',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                borderColor: isToDateCalOpen ? '#1B1D21' : '#DEE4EB',
                opacity: !fromDate ? 0.5 : 1
            },
            onClick: function () { return openToDateCalendar(); },
            disabled: !fromDate
        }, /*#__PURE__*/ React.createElement("img", {
            id: "cal-icon-to",
            src: CalenderIconBlack,
            alt: "calander"
        }), /*#__PURE__*/ React.createElement(Typography, {
            id: "to-date",
            variant: "body2",
            sx: {
                marginLeft: '2px',
                color: '#1B1D21',
                opacity: toDate ? 1 : 0.5
            }
        }, toDate || 'To date'.concat(" ", toDateError ? '*' : ''))))), isFromDateCalOpen && isFromNewDashboard && /*#__PURE__*/ React.createElement(LocalizationProvider, {
            dateAdapter: AdapterDayjs
            //localeText={{ cancelButtonLabel: 'Cancel', okButtonLabel: 'Apply' }}
        }, /*#__PURE__*/ React.createElement(DemoContainer, {
            components: ['StaticDatePicker']
        }, /*#__PURE__*/ React.createElement(DemoItem, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: newTheme
        }, /*#__PURE__*/ React.createElement(StaticDatePicker, {
            value: dayjs(fromDate)
            //format="MMM DD, YYYY"
            ,
            onChange: function (value) { return onFromDateCalendarClick(value); },
            slots: {
                toolbar: undefined,
                switchViewIcon: undefined
            },
            onClose: function () {
                setOpenCaledarFilter(false);
                setIsFromDateCalOpen(false);
                setIsToateCalOpen(false);
            },
            slotProps: {
                actionBar: {
                    actions: []
                }
            },
            onAccept: function (value) { return console.log(value); }
            // minDate={dayjs(new Date).subtract(30, 'day')}
            // maxDate={dayjs(new Date)}
        }))))), isToDateCalOpen && isFromNewDashboard && /*#__PURE__*/ React.createElement(LocalizationProvider, {
            dateAdapter: AdapterDayjs
        }, /*#__PURE__*/ React.createElement(DemoContainer, {
            components: ['StaticDatePicker']
        }, /*#__PURE__*/ React.createElement(DemoItem, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: newTheme
        }, /*#__PURE__*/ React.createElement(StaticDatePicker, {
            slots: {
                toolbar: undefined,
                switchViewIcon: undefined
            },
            value: dayjs(toDate),
            onChange: function (value) { return onToDateCalendarClick(value); },
            onClose: function () { return setOpenCaledarFilter(false); },
            slotProps: {
                actionBar: {
                    actions: []
                }
            },
            onAccept: function (value) { return console.log(value); }
            //minDate={dayjs(fromDate)}
            ,
            minDate: dayjs(fromDate),
            maxDate: dayjs(fromDate).add(MaxDateRange ? Number(MaxDateRange.Value) : maxDays, 'day')
        }))))), /*#__PURE__*/ React.createElement(Divider, {
            style: {
                width: '100%'
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'row',
            marginTop: "16px",
            justifyContent: "space-between",
            alignItems: 'center',
            padding: "0px 20px 10px 10px"
        }, /*#__PURE__*/ React.createElement(Button, {
            id: "reset",
            sx: {
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px'
            },
            onClick: function () { return onResetClick(); }
        }, "Reset"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onCancelClick(); },
            name: t('Cancel'),
            size: "large",
            sx: {
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px'
            }
        }), /*#__PURE__*/ React.createElement(MuiButton, {
            disabled: !(fromDate && toDate),
            onClick: function () { return onApplyClick(); },
            name: t('Apply'),
            size: "large",
            variant: "contained",
            sx: {
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px',
                marginLeft: '8px',
                opacity: !(fromDate && toDate) ? 0.7 : 1
            }
        }))))), !IS_MOBILE && !isDashboard && /*#__PURE__*/ React.createElement(React.Fragment, null, selectViewContentDesktop, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        py: 2,
        px: 3,
        bgcolor: "secondary.100",
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "secondary.200",
        columnGap: 2
    }, !isFromNewDashboard && /*#__PURE__*/ React.createElement(Stack, {
        id: "search-container",
        direction: "row",
        justifyContent: 'flex-start',
        flexGrow: 1,
        maxWidth: 400
    }, /*#__PURE__*/ React.createElement(DashboardSearch, {
        request: getRequest(),
        moduleName: moduleName,
        isSearchActive: isSearchActive,
        selectedMenuItem: selectedMenuItem
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end',
        columnGap: 2,
        alignItems: "center"
    }, loadingState === 'loading' ? null : /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            backgroundColor: '#EFF2F5',
            padding: '4px'
        }
    }, /*#__PURE__*/ React.createElement(ToggleIconButtonComponent, {
        activeView: activeView,
        onToggleView: function (value) {
            onToggleView(value);
            trackButtonClick("ButtonClickEvent", "Desktop_" + "".concat(value) + "_Click", undefined);
        },
        moduleName: moduleName
    })), /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        size: IS_DESKTOP ? 'small' : 'icon',
        onClick: function () {
            handleClickFilterIcon();
            trackButtonClick("ButtonClickEvent", "Desktop_Filter_Open", undefined);
        },
        id: "filterButtonId",
        color: "secondary"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "".concat(Config.CDNBaseURL, "filterButtonNew.svg"),
        id: "filterIcon",
        alt: "settingIcon",
        loading: "lazy",
        style: {
            margin: '-10px'
        }
    }), IS_DESKTOP ? 'More Filter' : null), isCreateButton && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        size: "small",
        color: "primary",
        id: "createAppointmentButton",
        onClick: function () {
            onClickCreateModule();
            trackButtonClick("ButtonClickEvent", "".concat(createButtonText) + " click", undefined);
        },
        name: createButtonText,
        variant: "contained",
        sx: {
            textWrap: 'nowrap'
        },
        startIcon: /*#__PURE__*/ React.createElement(Add, {
            color: "inherit"
        })
    }, "New"))))), isFromDashboard && /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ React.createElement(Typography, null, localFromDate != null ? formDateFormate(localFromDate) : formDateFormate(new Date()), " - ", localToDate != null ? formDateFormate(localToDate) : formDateFormate(new Date()))));
};
export default ListPageHeaderComponent;
